(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-menu"] && !Shopify.designMode) return;
  try {
    
  class SecondaryNav extends HTMLElement {
      connectedCallback() {
        this._triggers = Array.from(this.querySelectorAll('.secondary-nav__trigger'));
        this._dropdowns = Array.from(this.querySelectorAll('.secondary-nav__dropdown'));
        this._active = null;
        this._closeTimer = null;

        this._triggers.forEach(trigger => {
          trigger.addEventListener('mouseenter', this._onTriggerEnter.bind(this));
          trigger.addEventListener('click', this._onTriggerClick.bind(this));
          trigger.closest('.secondary-nav__item').addEventListener('mouseleave', this._onItemLeave.bind(this));
        });

        this._dropdowns.forEach(dropdown => {
          dropdown.addEventListener('mouseenter', () => clearTimeout(this._closeTimer));
          dropdown.addEventListener('mouseleave', this._onItemLeave.bind(this));
        });

        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this._closeAll();
        });

        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this._closeAll();
        });

        // Watch the list and each item (item widths change when web fonts load)
        this._items = Array.from(this.querySelectorAll('.secondary-nav__item'));
        if (this._items.length && 'ResizeObserver' in window) {
          this._resizeObserver = new ResizeObserver(() => this._updateClipped());
          this._resizeObserver.observe(this.querySelector('.secondary-nav__list'));
          this._items.forEach(item => this._resizeObserver.observe(item));
        }
      }

      disconnectedCallback() {
        if (this._resizeObserver) this._resizeObserver.disconnect();
      }

      // Items that wrapped to a second row are clipped by the list's overflow: hidden.
      // Hide them properly so they can't be tabbed to or read out.
      _updateClipped() {
        const firstRowTop = this._items[0].offsetTop;
        this._items.forEach(item => {
          const clipped = item.offsetTop > firstRowTop;
          item.classList.toggle('secondary-nav__item--clipped', clipped);
          const trigger = item.querySelector('.secondary-nav__trigger');
          if (clipped && trigger && trigger.getAttribute('aria-expanded') === 'true') this._closeAll();
        });
      }

      _onTriggerEnter(e) {
        clearTimeout(this._closeTimer);
        this._open(e.currentTarget);
      }

      _onTriggerClick(e) {
        const trigger = e.currentTarget;
        if (trigger.getAttribute('aria-expanded') === 'true') {
          this._closeAll();
        } else {
          this._open(trigger);
        }
      }

      _onItemLeave() {
        this._closeTimer = setTimeout(() => this._closeAll(), 150);
      }

      _open(trigger) {
        const id = trigger.getAttribute('aria-controls');
        const dropdown = document.getElementById(id);
        if (!dropdown) return;

        if (this._active && this._active !== dropdown) {
          this._close(this._active);
        }

        dropdown.removeAttribute('hidden');
        dropdown.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        this._active = dropdown;
      }

      _close(dropdown) {
        dropdown.setAttribute('hidden', '');
        dropdown.setAttribute('aria-hidden', 'true');
        const trigger = this.querySelector(`[aria-controls="${dropdown.id}"]`);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (this._active === dropdown) this._active = null;
      }

      _closeAll() {
        this._dropdowns.forEach(d => this._close(d));
      }
    }

    customElements.define('secondary-nav', SecondaryNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
